var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Data da emissão:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.dataEmissao))])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Número do processo:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.numeroProcesso))])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Nome/Razão social do interessado:"),
              _c("span", [
                _vm._v(_vm._s(_vm.documento.nomeRazaoSocialDoInteressado))
              ])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Protocolo:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.protocolo))])
            ])
          ]),
          _c("el-col", { attrs: { sm: 24 } }, [
            _c("p", { staticClass: "info" }, [
              _vm._v("Número do título/certidão:"),
              _c("span", [_vm._v(_vm._s(_vm.documento.numeroTituloCertidao))])
            ])
          ]),
          _vm._t("validacao_assinatura"),
          _vm._t("baixar"),
          _vm.isMaranhao
            ? _c("el-col", { attrs: { sm: 24 } }, [
                _c("p", { staticClass: "info info-green" }, [
                  _vm._v(
                    "Documento validado pelo Instituto de Colonização e Terras - ITERMA."
                  ),
                  _c("span", [
                    _vm._v(_vm._s(_vm.documento.numeroTituloCertidao))
                  ])
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      !_vm.documento.tituloCancelado
        ? _c("el-row", { staticClass: "dados-doc" }, [
            !_vm.isMaranhao
              ? _c(
                  "div",
                  { staticClass: "link-download" },
                  [
                    _c("font-awesome-icon", { attrs: { icon: "link" } }),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://validar.iti.gov.br/",
                          target: "_blank"
                        }
                      },
                      [_vm._v("  Link para validação da assinatura")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "link-download" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: "cloud-download-alt" }
                }),
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.downloadDoc()
                      }
                    }
                  },
                  [_vm._v("  Baixar Documento")]
                )
              ],
              1
            )
          ])
        : _c("el-row", [
            _c("p", { staticClass: "info-red" }, [_vm._v("Título cancelado!")])
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fcea521", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fcea521","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/TituloCertidao.vue
// module id = null
// module chunks = 